export const paths = {
  INCOMING: 'incoming',
  OUTGOING: 'outgoing',
}

export const piecesLinks = {
  incomingPiecesLink: () => `/${paths.INCOMING}`,
  outgoingPiecesLink: () => `/${paths.OUTGOING}`,
}

export type PiecesLinks = typeof piecesLinks
